import { render, staticRenderFns } from "./FooterBottom.vue?vue&type=template&id=53ecfc8f"
import script from "./FooterBottom.vue?vue&type=script&lang=js"
export * from "./FooterBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports